<template>
  <transition
    name="fadeInUp"
    enter-active-class="animated fadeInDown"
    leave-active-class="animated fadeOutUp"
    mode="out-in"
  >
    <div :class="['menu-mobile', { 'menu-mobile--negative': negative }]">
      <main-header :fixed="true" :cleanMode="true" :negative="negative" />
      <close-icon v-if="!negative" class="menu-mobile__close" @click="toggleMenuMobile" />
      <close-icon-white v-if="negative" class="menu-mobile__close" @click="toggleMenuMobile" />

      <section>
        <sui-grid :columns="2">
          <sui-grid-row>
            <sui-grid-column :width="5" class="menu-mobile__languages">
              <ul>
                <li :class="[{ active: $i18n.locale === 'en' }]" @click="setLanguage('en')">
                  <span>/</span>
                  Hello
                </li>
                <li :class="[{ active: $i18n.locale === 'es' }]" @click="setLanguage('es')">
                  <span>/</span>
                  Hola
                </li>
                <li :class="[{ active: $i18n.locale === 'pt' }]" @click="setLanguage('pt')">
                  <span>/</span>
                  Olá
                </li>
              </ul>
            </sui-grid-column>
            <sui-grid-column :width="11" class="menu-mobile__menu">
              <ul>
                <router-link to="/works">
                  <li :class="[{ active: $route.name === 'works' || $route.name === 'work' }]">
                    {{ $t("menus.work") }}
                  </li>
                </router-link>
                <router-link to="/news">
                  <li :class="[{ active: $route.name === 'news' || $route.name === 'SingleNews' }]">
                    {{ $t("menus.news") }}
                  </li>
                </router-link>
                <router-link to="/about">
                  <li :class="[{ active: $route.name === 'AboutUs' }]">{{ $t("menus.about") }}</li>
                </router-link>
                <router-link to="/contact">
                  <li :class="[{ active: $route.name === 'Contact' }]">
                    {{ $t("menus.contact") }}
                  </li>
                </router-link>
              </ul>
            </sui-grid-column>
          </sui-grid-row>
        </sui-grid>
      </section>
    </div>
  </transition>
</template>

<script>
import CloseSVG from "../../../assets/close.svg";
import CloseSVGWhite from "../../../assets/close-white.svg";

export default {
  name: "menu-mobile",

  props: {
    negative: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    "close-icon": CloseSVG,
    "close-icon-white": CloseSVGWhite,
  },

  data() {
    return {
      itemsVisible: false,
    };
  },

  mounted() {},

  methods: {
    setLanguage(language) {
      this.$hub.$emit("setLanguage", language);
    },

    toggleMenuMobile() {
      this.$hub.$emit("toggleMenuMobile");
      this.itemsVisible = !this.itemsVisible;
    },
  },
};
</script>

<style lang="scss">
.fadeInUp {
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
  -webkit-animation-duration: 0.5s !important;
  animation-duration: 0.5s !important;
}

.fadeOutDown {
  -webkit-animation-name: fadeOutDown;
  animation-name: fadeOutDown;
  -webkit-animation-duration: 0.3s !important;
  animation-duration: 0.3s !important;
}

.menu-mobile {
  width: 100%;
  height: 100%;
  position: fixed;
  background: white;
  top: 0;
  z-index: 7;
  box-shadow: 0 11px 38px 41px #f1f1f1;
  overflow-x: hidden;
  padding-top: 80px;

  .active {
    color: black;
    text-decoration: underline;
  }

  &__languages {
    padding: 0 20px;

    &--separator {
      margin-right: 10px;
    }
  }

  ul {
    padding: 0;
    margin: 0;
    display: flex;
    width: 100%;
    flex-direction: column;

    li {
      list-style: none;
      font-size: 14px;
      color: black;
      cursor: pointer;
      transition: color 0.2s ease-in-out;
      font-family: $hwcigars;
      font-weight: 300;
      margin: 20px 0 20px 20px;
      font-size: 15px;

      &:hover {
        transition: color 0.2s ease-in-out;
        color: black;
      }
    }
  }

  &__menu {
    ul {
      li {
        font-size: 27px;
        padding-left: 30px;
        letter-spacing: 1px;
      }
    }
  }

  &__close {
    position: absolute;
    right: 0;
    top: 10px;
    z-index: 6;

    svg,
    image {
      width: 18px;
    }
  }

  &--negative {
    box-shadow: 0 11px 38px 41px black;

    &.menu-mobile {
      background: black;

      ul {
        li {
          color: white;
        }
      }
    }
  }
}
</style>
